import store from '@/store/index'
import service from '@/services/system/SystemService'

let apiURL =
  localStorage.getItem('API_URL') ||
  process.env.VUE_APP_BASEURL ||
  'http://localhost:8000/api/'

let userSavedRoutes =
  JSON.parse(localStorage.getItem('quickAccessRoutes')) || []

export const systemModule = {
  namespaced: true,
  strict: process.env.NODE_ENV !== 'production',
  state: {
    apiURL: apiURL,
    systemList: [],
    currentSystem: null,
    codigoItemDiversos: '',
    quickAccessList: userSavedRoutes,
  },
  mutations: {
    SETAPIURL(state, payload) {
      if (localStorage.getItem('API_URL')) localStorage.removeItem('API_URL')
      payload = new URL(payload)
      const exist = payload.href.endsWith('/')
      payload = !exist ? payload.href + '/' : payload.href
      localStorage.setItem('API_URL', payload)
      state.apiURL = payload
    },
    SET_SYSTEM_LIST(state, payload) {
      payload.ITEMDIVERSOS
        ? (state.codigoItemDiversos = payload.ITEMDIVERSOS)
        : (state.codigoItemDiversos = '000000')
      state.systemList = payload
    },
    SET_SYSTEM(state, payload) {
      state.currentSystem = JSON.parse(JSON.stringify(payload))
      delete state.currentSystem.flags
    },
    SET_QUICK_ACCESS_LIST(state, payload) {
      state.quickAccessList = payload
    },
  },
  actions: {
    async setApiURL({ commit }, apiURL) {
      await commit('SETAPIURL', apiURL)
    },
    async setSystem({ commit, dispatch }, payload) {
      await commit('SET_SYSTEM', payload)

      let authUser = { ...store.state.authModule.authUser }

      if (authUser && payload.flags && !authUser.guest) {
        await dispatch('flagsModule/setFlags', payload.flags, {
          root: true,
        })
        if (authUser.filial !== payload.CODIGO) {
          authUser.filial = payload.CODIGO

          // fazer update das informações do authUser
          await dispatch('authModule/updateLoginInfo', authUser, {
            root: true,
          })
        }
      } else
        await dispatch('flagsModule/setFlags', [], {
          root: true,
        })
    },
    async getSystems({ commit }, query) {
      let response = await service.getSystems(query)

      commit('SET_SYSTEM_LIST', response)
    },
    async getSystem({ dispatch }, query) {
      let systemResponse = await service.getSystem(query)

      await dispatch('setSystem', systemResponse)
    },
    setQuickAccessList({ commit }, payload) {
      commit('SET_QUICK_ACCESS_LIST', payload)
    },
  },
  getters: {
    getApiURL: (state) => state.apiURL,
    getSystems: (state) => {
      return state.systemList.map((system) => ({
        DESCRICAO: system.CODIGO + ' - ' + system.NOME,
        FILIAL: system.CODIGO,
        ...system,
      }))
    },
    getCurrentSystem: (state) => {
      if (!store.state.authModule.authUser) return

      let filial = store.state.authModule.authUser.filial
      let system = state.currentSystem ??
        state.systemList.find((system) => system.CODIGO === filial) ?? {
          NOME: '',
          CODIGO: '',
        }

      return system
    },
    getSystemCurrencies: (state) => {
      if (!store.state.authModule.authUser) return

      let filial = store.state.authModule.authUser.filial
      let system = state.systemList.find((system) => system.CODIGO === filial)
      let currencyArray = []
      if (system) {
        for (let i = 0; i < 6; i++) {
          if (system[`MOEDA${i}`]) {
            let currencyObject = {
              descricao: system[`MOEDA${i}`] || `Moeda ${i}`,
              mascara: system[`MASCARA${i}`] || '',
              cifrao: system[`CIFRAO${i}`] || '',
              sinal: system[`SINAL${i}`] || '',
              principal: system['MOEDAPRINCIPAL'] == i,
              show: system[`CIFRAO${i}`] ? true : false,
              index: i,
            }
            // currencyArray.push(currencyObject)
            currencyArray[i] = currencyObject
          }
        }
        return currencyArray
      }
    },
    getComboBoxListSystems: (state) => {
      let comboBox = state.systemList.map((system) => {
        return {
          CODIGO: system.CODIGO,
          DESCRICAO: system.CODIGO + ' - ' + system.NOME,
        }
      })
      return comboBox
    },
    getCodigoItemDiversos: (state) => {
      return state.codigoItemDiversos
    },
    getQuickAccessList: (state) => {
      var userRoutes = state.quickAccessList.find(
        (route) => route.user === store.state.authModule.authUser.NOME
      )
      if (userRoutes)
        userRoutes = userRoutes.routes.filter((route) => route.quickAccess)
      return userRoutes || []
    },
  },
}
